// TASKOVERDUE: one definition of "overdue" for every task list, mirroring the backend's
// services/task_overdue.py. An overdue task is still PENDING (its status never changes), so it is
// listed in Pending, first, with a red "Overdue" label beside its original due date.
import React from 'react';
import { useTranslation } from 'react-i18next';

export const OVERDUE_RED = '#A63A3A';

// The server's flag when it sent one; otherwise the same rule computed here.
export function isTaskOverdue(task, now = Date.now()) {
  if (!task) return false;
  if (typeof task.overdue === 'boolean') return task.overdue;
  return task.status === 'pending' && Boolean(task.due_date) && new Date(task.due_date).getTime() < now;
}

// Overdue first (oldest due date first), then the rest by due date, undated last. Stable for ties.
export function sortPendingTasks(list, now = Date.now()) {
  const key = (t) => [isTaskOverdue(t, now) ? 0 : 1,
                      t.due_date ? 0 : 1,
                      t.due_date ? new Date(t.due_date).getTime() : 0];
  return [...(list || [])].map((t, i) => [t, i]).sort((a, b) => {
    const ka = key(a[0]);
    const kb = key(b[0]);
    for (let j = 0; j < ka.length; j += 1) {
      if (ka[j] !== kb[j]) return ka[j] - kb[j];
    }
    return a[1] - b[1];
  }).map(([t]) => t);
}

export function OverdueLabel() {
  const { t } = useTranslation();
  return (
    <span data-testid="task-overdue"
          style={{ fontSize: '11px', fontWeight: 600, color: OVERDUE_RED, background: '#FDF0F0',
                   border: `1px solid ${OVERDUE_RED}`, borderRadius: '10px', padding: '1px 8px',
                   whiteSpace: 'nowrap', flexShrink: 0 }}>
      {t('taskOverdue.label')}
    </span>
  );
}
